import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { LegendItem } from '../../../components/Legend';
import styles from './CropWaterLegend.css';
import { getCurrentEvent } from '../../../selectors/eventSelectors';
import { parseCropWaterUseLegend } from '../../../utils/layerData/mosaic/cropWaterUse';
import LegendInfo from '../../../components/Legend/LegendInfo';

export function CropWaterLegend({ intervals = [], labelHigh, testId }) {
  return (
    <div>
      <div
        className={styles.legendContainer}
        data-test-id={`${testId}-inSeason-cropWater`}
      >
        <LegendItem intervals={intervals} labelHigh={labelHigh} />
      </div>
      <div className={`${styles.legendContainer}`}>
        <LegendInfo
          contentStringKey="card.cropwateruse.info"
          titleStringKey="layer.cropwateruse"
        />
      </div>
    </div>
  );
}

CropWaterLegend.propTypes = {
  intervals: PropTypes.array.isRequired,
  labelHigh: PropTypes.string.isRequired,
  testId: PropTypes.string.isRequired,
};

function mapStateToProps(state, props) {
  const { legend } = getCurrentEvent(state, props);
  const { intervals, labelHigh } = parseCropWaterUseLegend(legend);

  return { intervals, labelHigh };
}

export default connect(mapStateToProps)(CropWaterLegend);
